import { Form } from 'antd';
import { InputSearch, Select } from 'basic-ui-lib';
import { debounce } from 'lodash';
import { StatusOptions } from 'modules/dashboard/services/constants';
import { useGetAllStores } from 'modules/dashboard/services/hooks';
import useGetListScreens from 'modules/dashboard/services/hooks/useGetListScreens';
import { useEffect, useMemo } from 'react';
import styled from 'styled-components';

type FormValues = {
  keySearch: string;
  status: string;
  storeId: string;
};

const ScreenFilter = () => {
  const [form] = Form.useForm<FormValues>();
  const { mutate } = useGetListScreens(true);
  const [stores] = useGetAllStores();

  const onFinish = (values: FormValues) => {
    mutate({
      keySearch: values.keySearch || '',
      status: values.status || '',
      storeId: values.storeId || '',
      page: 1,
      size: 10,
    });
  };

  const debouncedSearch = useMemo(
    () =>
      debounce(() => {
        form.submit();
      }, 500),
    [form]
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const storeOptions = useMemo(() => {
    return stores.map((store) => ({
      label: store.storeName,
      value: store.storeId,
    }));
  }, [stores]);

  return (
    <Container>
      <Form form={form} layout='vertical' className='form-container' onFinish={onFinish}>
        <Form.Item name='keySearch' noStyle>
          <InputSearch placeholder='Search screens by name, location,...' onChange={debouncedSearch}/>
        </Form.Item>
        <Form.Item name='status' noStyle>
          <Select options={StatusOptions} onChange={() => form.submit()} />
        </Form.Item>
        <Form.Item name='storeId' noStyle>
          <Select options={storeOptions} onChange={() => form.submit()} />
        </Form.Item>
      </Form>
    </Container>
  );
};

export default ScreenFilter;

const Container = styled.div`
  width: 100%;

  .form-container {
    width: 100%;
    display: flex;
    gap: 16px;
  }

  .custom-select .ant-select-selector {
    width: 180px;
  }
`;
